type CopyToClipboardResponseType = {
    success: boolean,
    error?: string
}

export const copyToClipboard = async (text: string): Promise<CopyToClipboardResponseType> => {
    if (!text) return { success: false, error: 'common.no-data' };

    if (!navigator.clipboard) {
        return {
            success: false,
            error: 'browser.not-support'
        }
    }

    let result: CopyToClipboardResponseType = {
        success: false,
        error: ''
    }

    try {
        await navigator.clipboard.writeText(text);
        result.success = true;
    } catch (error: any) {
        console.error(error);
        result.error = error.message
    }

    return result;
}


export const removeAt = <T>(list: T[], index: number) => {
    if (!list || !list.length) return list;
    const data = [...list];
    data.splice(index, 1);
    return data;
}

export function onlyUnique<T>(value: T, index: number, self: T[]) {
    return self.indexOf(value) === index;
} 


export enum Roles {
    ADMIN = "Admin",
    PERSON_WRITE = "Person.Write",
    PERSON_READ = "Person.Read",
    AGRICULTURE_SALES_READ = "Agriculture.Sales.Read",
    AGRICULTURE_SALES_WRITE = "Agriculture.Sales.Write",
    AGRICULTURE_WORK_READ = "Agriculture.Work.Read",
    AGRICULTURE_WORK_WRITE = "Agriculture.Work.Write",
    ACCOMMODATION_BOOKINGS_READ = "Accommodation.Bookings.Read",
    ACCOMMODATION_BOOKINGS_WRITE = "Accommodation.Bookings.Write",
    ACCOMMODATION_WORK_READ = "Accommodation.Work.Read",
    ACCOMMODATION_WORK_WRITE = "Accommodation.Work.Write",
}

export const isHidden = (hide?: any | (() => any)) => {
    if (typeof hide === 'function') {
        return hide() ? true : false;
    }
    const result = hide === undefined || hide == null || !hide ? false : true;
    return result;
}

export const hasValidNumberValue = (value: any) => {
    const numberValue = Number(value);
    return numberValue !== undefined && numberValue !== null && isNaN(numberValue) === false && value !== '';
}
